module.exports = __webpack_public_path__ + "static/media/duplicate_dark.6191bfcd.svg";